<!-- ./src/pages/admin/Products.vue -->
<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Inscrições
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="contatos"
            :search="search"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.numero }}</td>
              <td>{{ props.item.nome }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.telefone }}</td>
              <!--td class="text-xs-right">{{ props.item.width }}</td>
              <td class="text-xs-right">{{ props.item.height }}</td-->
              <td >
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="teal">bookmark</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
          
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Inscrição</span>
        </v-card-title>
        <v-card-text>
          Inscrição: {{data.numero}} <br>
          Nome: {{data.nome?data.nome.toUpperCase():''}} <br>
          Ramo: {{data.ramo}} <br>
          Nascimento: {{data.dtNascimento}} <br>
          Nome Pai: {{data.nomePai?data.nomePai.toUpperCase():''}} <br>
          Nome da Mãe: {{data.nomemae?data.nomemae.toUpperCase():''}} <br>
          Local de Nascimento: {{data.localNascimento}} <br>
          Conjuge: {{data.conjuge}} <br>
          Data Casamento: {{data.dtCasamento}} <br>
          Endereço: {{data.endereco?data.endereco.toUpperCase():''}} <br>
          Email: {{data.email}} <br>
          Telefone: {{data.telefone}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="clear()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click.native="dialogConfirmation = false">Não</v-btn>
          <v-btn color="green darken-1" flat @click.native="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
import usuario from "@/services/usuario";

  export default {
    name: 'home',
    data () {
      return {
        search: '',
        snackbar: false,
        message: '',
        loading: true,
        dialog: false,
        dialogError: false,
        dialogConfirmation: false,
        editando: false,
        excluindo: {},
        idZabbix: '',
        contatos: [],
        options: ['Admin'],
        data: {
          nome: "",
          endereco: "",
          nomemae: "",
          nomePai: ""
        },
        headers: [
          {
            text: 'Inscrição',
            align: 'center',
            sortable: true,
            value: 'numero'
          },
          {
            text: 'Nome',
            align: 'left',
            sortable: true,
            value: 'nome'
          },{
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'email'
          },{
            text: 'Telefone',
            align: 'left',
            sortable: true,
            value: 'telefone'
          },
          { text: 'Ações' }
        ]
      }
    },
    created () {
      usuario.getContatos().then((res) => {
        let num = 1;
        res.forEach(element => {
          element.numero = num++; 
        });
        this.contatos = res;
      });
    },
    methods: {
      deleteItem: function (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          usuario.deleteContato(even._id).then((res) => {
            this.dialogConfirmation = false;
            this.excluindo = null;
            
            usuario.getContatos().then((res) => {
              let num = 1;
              res.forEach(element => {
                element.numero = num++; 
              });
              this.contatos = res;
            });
          });
        }
      },
      editItem: function (even) {
        this.dialog = true;
        this.editando = true;
        this.data = even;
        this.data.internal = undefined;
        this.data.flags = undefined;
      },
      clear: function () {
        this.data =  {
          nome: "",
          endereco: "",
          nomemae: "",
          nomePai: ""
        }
        this.editando = false;
        this.$validator.reset()
        this.dialog = false;
      }

    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/user/Contatos.vue